import { authGet, authPost, doPost } from "./ApiClient";

const baseUrl = "http://35.240.204.237/ok99memberApi/api";

export function fetchWalletInfo() {
  return authGet(`${baseUrl}/MemberPc2/PcHomePageBalance`, {});
}

export function changeLanguage(params) {
  return authPost(`${baseUrl}/Member2/ChangeLanguage`, params);
}
export function getContactLists(params) {
  return doPost(`${baseUrl}/Member8/ContactLists`, params);
}
